module.exports = __webpack_public_path__ + "static/in-life-account-management-62d91dccf2f2cbc61bf95ee10ae83aa0.svg";